import React from 'react';
import site from '../content/site';
import './LegalPage.css';

// Copy lives in src/content/site.js so this page and the build-time
// prerenderer render byte-identical text — see the note in that file.
const { TERMS_SECTIONS, LEGAL_LAST_UPDATED } = site;

export default function TermsOfServicePage() {
  return (
    <main className="legal-page">
      <div className="legal-page__inner">
        <h1 className="legal-page__title">Terms of Service</h1>
        <p className="legal-page__date">Last updated: {LEGAL_LAST_UPDATED}</p>

        {TERMS_SECTIONS.map((section, i) => (
          <section className="legal-section" key={section.heading}>
            <h2>{i + 1}. {section.heading}</h2>
            <p>{section.body}</p>
          </section>
        ))}
      </div>
    </main>
  );
}
